<template>
	<div>
		<v-client-table
			v-model="discoveries"
			:columns="fields"
			:options="options"
		>
			<router-link
				slot="edit"
				slot-scope="discoveries"
				class="nav-item"
				:to="`/discovery/${discoveries.row.discoveryId}`"
			>Edit</router-link>
		</v-client-table>
	</div>
</template>

<script>
import tableFields from './tableFields'

export default {
	props: {
		discoveries: {
			required: true,
			type: Array
		}
	},
	name: "DiscoveryTableList",
	components: {
	},
	data() {
		return {
			fields: tableFields,
			options: {
				resizableColumns: false,
				perPage: 10,
				perPageValues: [],
				filterable: false,
				highlightMatches: false,
				filterByColumn: false,
				skin: '',
				hiddenColumns: ['id'],
				headings: {
					delete: false,
					edit: false
				}
			}
		}
	}
}
</script>

<style scoped>

</style>